import React from 'react';
import PropTypes from 'prop-types';

import styles from './page.disclaimer.module.css';
import { sanitizeContent } from '../utils';
import Blocks from '../components/Blocks';

const Disclaimer = ({ pathContext: { subparts } }) => {
  const { disclaimer } = sanitizeContent(subparts, 'disclaimer');
  return (
    <div className={styles.wrapper}>
      <Blocks classNames={{ cards: styles.content }} headerTag="h1" content={disclaimer} />
    </div>
  );
};

Disclaimer.propTypes = {
  pathContext: PropTypes.shape({
    subparts: PropTypes.array.isRequired,
  }),
};

export default Disclaimer;



// WEBPACK FOOTER //
// ./src/templates/page.disclaimer.js